import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { onAuthStateChanged, User } from "firebase/auth";
import { auth } from "./firebase"; // Certifique-se de importar a instância do auth
import Home from "./pages/home/home";
import SignIn from './pages/login/Login';
import './global.css';
import SignUp from "./pages/signup/signup";
import CompleteProfile from "./pages/completeprofile/completeprofile";
import SelectCompanyAndRole from "./pages/signup/selectcompanyandrole";
import DetailPage from './pages/detail';
import ClientPage from './pages/clients/ClientPage';
import ProductPage from './pages/products/ProductPage';
import OpportunityFlow from './pages/configurations/flow/OpportunityFlow';
import ActivityType from './pages/configurations/activities/type/ActivityType';
import ActivityBranch from './pages/configurations/activities/branch/ActivityBranch';
import Source from './pages/configurations/source/Source';
import LeadPage from './pages/leads/LeadPage';
import ProtectedRoute from "./protectedRoute";
import { ClientProvider } from "./context/ClientContext";
import ProfilePage from "./pages/profilepage/profilePage";
import IndicatorsPage from "./pages/indicators/IndicatorsPage";
import ColaboradorPage from "./pages/colaborador/colaborador";
import EmailConfigPage from "./pages/marketing/setting/SettingEmail";
import { Toaster } from "./components/shadcn/ui/toaster";
import ContactForm from "./pages/contactForm/contactForm";
import Demo from "./pages/contactForm/demo";
import Levantamento from "./pages/detail/levantamento";
import GridCancelados from "./pages/grids/gridCancelados";
import GridAprovados from "./pages/grids/gridAprovados";
import PrintComponent from "./document/basicDocument";
import DashboardPage from "./pages/dashboard/dashboard";
import UserBusiness from "./pages/userBusiness/userBusiness";
import UserPage from "./pages/users/users";
import SellersPage from "./pages/sellers/SellersPage";
import GridDeclinados from "./pages/grids/gridDeclinados";
import EmailTemplatesPage from "./pages/marketing/template/TemplateEmail";

const App: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [hasToken, setHasToken] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      // Monitora o localStorage até encontrar um token válido
      const checkToken = setInterval(() => {
        const token = localStorage.getItem("APP_ACCESS_TOKEN");
        if (token) {
          setHasToken(true);
          clearInterval(checkToken);
        }
      }, 500); // Checa a cada 500ms

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading || (user && !hasToken)) {
    return <p>Loading...</p>;
  }

  return (

    <Router>
      <Toaster />
      <Routes>
      <Route path="/signin" element={!user ? <SignIn auth={auth} /> : <Navigate to="/" />} />
        <Route path="/signup" element={<ProtectedRoute element = {<SignUp auth={auth}/>} />} />
        <Route path="/company" element ={ <ProtectedRoute element={<SelectCompanyAndRole user={user} /> } /> }/>
        <Route path="/complete-profile/:userId" element={user ? <CompleteProfile userId={user.uid} /> : <Navigate to="/signin" />} />
        <Route path='/fluxo' element = { <ProtectedRoute element={<OpportunityFlow />} />}/>
        <Route path='/clientes' element = { <ProtectedRoute element={<ClientProvider><ClientPage /></ClientProvider>} />}/>
        <Route path='/ramoatividade' element = { <ProtectedRoute element={<ActivityBranch />} />}/>
        <Route path='/produtos' element = { <ProtectedRoute element={<ProductPage />} />}/>
        <Route path='/fonte' element = { <ProtectedRoute element={<Source />} />}/>
        <Route path='/detalhe/:leadId' element = { <ProtectedRoute element={<DetailPage />} />}/>
        <Route path='/tipoatividade' element = { <ProtectedRoute element={<ActivityType />} />}/>
        <Route path='/negocios' element = { <ProtectedRoute element={<LeadPage />} />}/>  
        <Route path="/profile-screen" element={ <ProtectedRoute element={<ProfilePage />} />}/>
        <Route path="/indicadores" element={ <ProtectedRoute element={<IndicatorsPage />} />}/> 
        <Route path="/colaboradores" element={<ProtectedRoute element={<ColaboradorPage />} />} />
        <Route path="/settingEmail" element={<ProtectedRoute element={<EmailConfigPage />} />} />
        <Route path="/templateEmail" element={<ProtectedRoute element={<EmailTemplatesPage />} />} />
        <Route path="/formulario" element={!user ? <ContactForm/> : <Navigate to="/"/>}  />
        <Route path="/demo" element={!user ? <Demo/> : <Navigate to="/"/>}  />
        <Route path="/levantamento/:leadId" element={<ProtectedRoute element={<Levantamento />} />} />
        <Route path="/declinados" element={<ProtectedRoute element={<GridDeclinados />} />} />
        <Route path="/cancelados" element={<ProtectedRoute element={<GridCancelados />} />} />
        <Route path="/aprovados" element={<ProtectedRoute element={<GridAprovados />} />} />
        <Route path="/print/:leadId" element={<ProtectedRoute element={<PrintComponent />} />}/>
        <Route path='/kanban' element={<ProtectedRoute element={<DashboardPage />} />} />
        <Route path='/ub' element={<ProtectedRoute element={<UserBusiness />} />} />
        <Route path='/users' element={<ProtectedRoute element={<UserPage />} />} />
        <Route path='/sellers' element={<ProtectedRoute element={<SellersPage/>} />} />
      <Route path="/" element={user ? <Home auth={auth} /> : <Navigate to="/signin" />} />   
      </Routes>
    </Router>
  );
};

export default App;

//teste

